<template>
    <Internal>
        <form @submit.prevent="handleSettingForm"
              class="p-6 bg-white border-b border-gray-200  shadow-sm sm:rounded-lg">
            <p class="text-lg font-medium mb-4">
                Setting
            </p>
            <div class="grid gap-4 grid-cols-2">
                <div>
                    <Label value="Registration Fee"/>
                    <Input class="w-full" type="number" v-model="settingForm.registration_fee"/>
                </div>
                <div>
                    <Label value="Late fee charge"/>
                    <Input class="w-full" type="number" v-model="settingForm.late_fee_charge"/>
                </div>
            </div>
            <div class="mt-4 flex space-x-4 items-center">
                <Button :disabled="settingForm.processing">Submit</Button>
                <p class="text-sm text-green-700">
                    {{ settingForm.success_message }}
                </p>
            </div>

        </form>
    </Internal>
</template>
<script setup>
import Internal from "@/Pages/Internal/Internal.vue";
import Button from "@/Components/Button.vue";
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import Label from "@/Components/Label.vue";
import Input from "@/Components/Input.vue";

const setting = usePage().props.value?.setting;
const settingForm = useForm({
    registration_fee: setting?.registration_fee ?? 0,
    late_fee_charge: setting?.late_fee_charge ?? 0,
    success_message: '',
});

const handleSettingForm = () => {
    settingForm.post(route('internal.settings.store', localStorage.branchId), {
        onSuccess: showSuccessMessage
    });
}

const showSuccessMessage = () => {
    settingForm.success_message = 'Setting updated successfully';
    setTimeout(() => {
        settingForm.success_message = '';
    }, 3000);
}
</script>
